import { put, takeLatest } from 'redux-saga/effects';
import * as actionType from './actionTypes';
import {
  setEntityDialogAskConfirmationAction,
  setEntityDialogComponentNameAction,
  setEntityDialogDataLoadedStatusAction,
  setEntityDialogLoadingStatusAction,
  setEntityDialogTitleAction,
  setEntityDialogTitleAppenderAction,
  setEntityDialogVisibilityStatusAction,
} from './actions';

function* openEntityDialogSaga(action) {
  const { componentName, dataLoading, dataLoaded, title, show, titleAppender, askConfirmation } = action.payload;

  if (show) {
    yield put(setEntityDialogVisibilityStatusAction.Completed(true));
    yield put(setEntityDialogDataLoadedStatusAction.Completed(dataLoaded));
    yield put(setEntityDialogLoadingStatusAction.Completed(dataLoading));
    yield put(setEntityDialogTitleAction.Completed(title));
    yield put(setEntityDialogComponentNameAction.Completed(componentName));
    yield put(setEntityDialogTitleAppenderAction.Completed(titleAppender || ""));
    yield put(setEntityDialogAskConfirmationAction.Completed(askConfirmation));
  } else {
    yield put(setEntityDialogVisibilityStatusAction.Completed(false));
    yield put(setEntityDialogDataLoadedStatusAction.Completed(false));
    yield put(setEntityDialogLoadingStatusAction.Completed(false));
    yield put(setEntityDialogTitleAction.Completed(''));
    yield put(setEntityDialogComponentNameAction.Completed(null));
    yield put(setEntityDialogTitleAppenderAction.Completed(''));
    yield put(setEntityDialogAskConfirmationAction.Completed(false));
  }
}

export default function* entityDialogRootSaga() {
  yield takeLatest(actionType.SET_ENTITY_DIALOG_VISIBILiTY_STATUS.TRIGGER, openEntityDialogSaga);
}
